import * as Yup from 'yup';
import validator from 'validator';
import { gender } from '../data';
import { drugAllergy, services } from '../data/DummyData';

import { duration } from 'moment';
const nameRegex = /^[A-Za-z\s]+$/;
const genderOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Other', value: 'Other' }
];
export const signupSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email format')
    .required('Please enter email')
    .test('is-gmail', 'Email must be a Gmail account', (value) => {
      return value ? value.endsWith('@gmail.com') : false;
    }),
  cellNumber: Yup.string()
    .required('Cell number is required')
    .matches(/^[0-9]{12,15}$/, 'Cell number must be between 13 digits'),
  role: Yup.string().required('Please select role'),
  readTermsAndCondition: Yup.boolean()
    .oneOf([true], 'You must agree to the terms and conditions')
    .required('Please agree to the terms and conditions')
});

export const appointmentReminderSchema = Yup.object({
  quantity: Yup.object()
    .shape({
      value: Yup.string()
        // Ensures the value is either 'minute' or 'hour'
        .required('Time quantity is required'),
      label: Yup.string().required('Label is required')
    })
    .nullable()
    .required('Time quantity selection is required'),
  time: Yup.number().required('Time is required')
});

export const otpVerificationSchema = Yup.object().shape({
  otp: Yup.string().required('OTP is required').length(6, 'OTP must be 6 digits')
});

export const furtherStepSchema = Yup.object().shape({
  pinCode: Yup.string()
    .matches(/^\d+$/, 'Pin code must be a number')
    .max(6, 'Pin code must be at most 4 digits')
    .required('Pin code is required'),
  confirmPinCode: Yup.string()
    .oneOf([Yup.ref('pinCode'), null], "Pin codes don't match")
    .matches(/^\d+$/, 'Confirm pin code must be a number')
    .required('Confirm pin code is required'),
  gender: Yup.object()
    .shape({
      value: Yup.string().required('Gender is required'),
      label: Yup.string().required('Gender is required')
    })
    .nullable()
    .required('Gender is required'), // Assuming gender is a string value
  dateOfBirth: Yup.date()
    .required('Date of birth is required')
    .max(new Date(), 'Date of birth cannot be in the future'),
  title: Yup.string().required('Required'),
  fullName: Yup.string().required('Name is required'),
  secondaryCellNumber: Yup.string()
    .required('Clinic Mobile number is required')
    .min(10, 'Clinic Mobile number must be at least 10 digits'),

  clinicCity: Yup.object().required('City is required'), // Assuming gender is a string value
  clinicState: Yup.object().required('Province is required'),
  clinicAddress: Yup.string().required('Address is Required'),
  clinicName: Yup.string().required('Clinic Name is required')
});

export const resetPinCode = Yup.object().shape({
  mobileNo: Yup.string()
    .required('Mobile number required')
    .min(10, 'Mobile number must be at least 10 digits')
    .test('is-valid-whatsapp', 'Invalid WhatsApp number', (value) => {
      return value && value.length >= 10; // basic validation for length, you can customize as needed
    })
});

export const personalInformation = Yup.object().shape({
  gender: Yup.object()
    .shape({
      value: Yup.string().required('Gender Is Required'),
      label: Yup.string().required('Gender Is Required')
    })
    .nullable()
    .required('Gender Is Required'), // Assuming gender is a string value
  dateOfBirth: Yup.date()
    .required('Date of birth is required')
    .max(new Date(), 'Date of birth cannot be in the future'),
  title: Yup.string().required('Required'),
  fullName: Yup.string().required('Name is required')
});

export const clinicInformation = Yup.object().shape({
  secondaryCellNumber: Yup.string()
    .required('Clinic Mobile number is required')
    .min(10, 'Clinic Mobile number must be at least 10 digits'),

  clinicCity: Yup.object().required('City is required'), // Assuming gender is a string value
  clinicState: Yup.object().required('Province is required'),
  clinicAddress: Yup.string().required('Address is Required'),
  clinicName: Yup.string().required('Clinic Name is required')
});

export const signInSchema = Yup.object().shape({
  mobileNo: Yup.string()
    .required('Cell number is required')
    .matches(/^[0-9]{12,15}$/, 'Cell number must be between 13 digits'),
  pinCode: Yup.string()
    .matches(/^\d+$/, 'Pin code must be a number')
    .max(4, 'Pin code must be at most 4 digits')
    .required('Pin code is required')
});

export const serviceSchema = Yup.object().shape({
  serviceName: Yup.string().required('Service name is required'),
  serviceFees: Yup.number().required('Service fee is required')
  // .moreThan(0, 'Fee must be greater than 0')
});
const genderValues = genderOptions.map((option) => option.value);
export const createPatientSchema = Yup.object().shape({
  email: Yup.string()
    .nullable() // Allows the field to be null or undefined
    .notRequired() // Makes the field optional
    .test('is-empty-or-valid', 'Invalid email format', (value) => {
      // Skip validation if the field is empty
      if (!value) return true;

      // Validate the format of the email
      const isValidFormat = Yup.string().email().isValidSync(value);

      // Ensure the email ends with '@gmail.com'
      const isGmail = value.endsWith('@gmail.com');

      return isValidFormat && isGmail;
    }),
  cellNumber: Yup.string()
    .required('Cell number is required')
    .matches(/^[0-9]{12,15}$/, 'Cell number must be between 13 digits'),

  fullName: Yup.string()
    .required('Full name is required')
    .matches(nameRegex, 'Full name can only contain alphabets and spaces')
    .min(2, 'Full name must be at least 2 characters'),
  // firstName: Yup.string()
  //   .required('First name is required')
  //   .matches(nameRegex, 'First name can only contain alphabets and spaces')
  //   .min(2, 'First name must be at least 2 characters'),

  // lastName: Yup.string()
  //   .required('Last name is required')
  //   .matches(nameRegex, 'Last name can only contain alphabets and spaces')
  //   .min(2, 'Last name must be at least 2 characters'),
  gender: Yup.object()
    .shape({
      value: Yup.string().required('Gender Is Required'),
      label: Yup.string().required('Gender Is Required')
    })
    .nullable()
    .required('Gender is required'),
  age: Yup.number()
    .required('Age is required')
    .min(1, 'Age must be greater than 0')
    .max(109, 'Age must be less than to 110')

  // isOpd: Yup.boolean().required('Is OPD is required'),
  // appliedFees: Yup.array()
  //   .of(
  //     Yup.object().test(
  //       'is-not-empty',
  //       'Each fee object must have at least one property',
  //       (value) => value && Object.keys(value).length > 0
  //     )
  //   )
  //   .required('At least one fee is required')
  //   .min(1, 'There must be at least one fee')
});

export const drugAllergySchema = Yup.object().shape({
  type: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string()
  }),
  drugAllergy: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string()
  })
});

export const longTermConditions = Yup.object().shape({
  dataValue: Yup.string()
    .required('long term condition is required')
    .min(2, 'long term condition must be at least 2 characters')
});

export const addOnsSchema = Yup.object().shape({
  dataValue: Yup.string()
    .required('long term condition is required')
    .min(2, 'long term condition must be at least 2 characters')
});
export const previousServicesAddOns = Yup.object().shape({
  services: Yup.string()
    .required('Service is required')
    .min(2, 'Service name must be at least 2 characters')
});

export const disabilityAddOns = Yup.object().shape({
  disability: Yup.string()
    .required('Service is required')
    .min(2, 'Service name must be at least 2 characters')
});

export const previousMedicationAddOns = Yup.object().shape({
  medicine: Yup.string()
    .required('Service is required')
    .min(2, 'Service name must be at least 2 characters')
});

export const symptomsAddOnsSchema = Yup.object().shape({
  symptoms: Yup.string()
    .required('Symptoms is required')
    .min(2, 'Symtoms name must be at least 2 characters')
});

export const vitalAddonsSchema = Yup.object().shape({
  bloodPressureOutOf: Yup.number()
    .typeError('Blood pressure out of must be a number')
    .min(0, 'Blood pressure out of cannot be negative')
    .max(999, 'Blood pressure out of cannot be more than 3 digits')
    .required('Blood pressure out of is required'),

  bloodPressure: Yup.number()
    .typeError('Blood pressure must be a number')
    .min(0, 'Blood pressure cannot be negative')
    .required('Blood pressure is required'),

  heartRate: Yup.number().required('Heart rate is required'),
  temperature: Yup.number().required('Temperature is required'),
  spo2: Yup.number().required('SpO2 is required'),
  sugarLevel: Yup.number().required('Sugar level is required')
});

export const testSchema = Yup.object().shape({
  test: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string()
  })
  // remarks: Yup.string().required('Remarks is required')
});
export const prescriptionFormSchema = Yup.object().shape({
  medicineName: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string()
  }),
  medicineType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string()
  })
  // duration: Yup.object().shape({
  //   label: Yup.string(),
  //   value: Yup.string()
  // }),
  // frequency: Yup.object().shape({
  //   label: Yup.string(),
  //   value: Yup.string()
  // })
});

export const paymentsSchema = (maxCharge) =>
  Yup.object({
    waiveAmount: Yup.number().max(
      maxCharge,
      `Additional charge cannot be greater than ${maxCharge}`
    )
  });

export const defineTime = Yup.object().shape({
  startTime: Yup.string().required('start Time Required'),
  endTime: Yup.string().required('start Time Required')
});

export const rescheduleAppointment = Yup.object().shape({
  // appliedFees: Yup.array()
  //   .of(
  //     Yup.object().test(
  //       'is-not-empty',
  //       'Each fee object must have at least one property',
  //       (value) => value && Object.keys(value).length > 0
  //     )
  //   )
  //   .required('At least one fee is required')
  //   .min(1, 'There must be at least one fee'),
  appointmentStartDateTime: Yup.date().required('Start date and time are required')

  // appointmentEndDateTime: Yup.string()
  //   .required('End date and time are required')
});

// const prescriptionFee = Yup.object().shape({
//   additionalCharge: Yup.number()
//     // .typeError('Additional charge must be a number')
//     .required('Additional charge is required')
//     .min(1, 'Additional charge must be at least 1'),
//   waiveAmount: Yup.number()
//     // .typeError('Additional charge must be a number')
//     .required('Waive Amount is required')
//     .min(1, 'Waive Amount must be at least 1'),
//   collectedAmount: Yup.string()
//   // duration: Yup.object().shape({
//   //   label: Yup.string(),
//   //   value: Yup.string()
//   // }),
//   // frequency: Yup.object().shape({
//   //   label: Yup.string(),
//   //   value: Yup.string()
//   // })
// });

export const createAppointmentSchema = Yup.object().shape({
  // email: Yup.string()
  //   .email('Invalid email format')

  //   .test('is-gmail', 'Email must be a Gmail account', (value) => {
  //     return value ? value.endsWith('@gmail.com') : false;
  //   }),

  appointmentStartDate: Yup.string().required('Appointment Start Date'),
  appointmentStartTime: Yup.object({}).required('Appointment Time')
});
export const emailSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email format')
    .required('Please enter email')
    .test('is-gmail', 'Email must be a Gmail account', (value) => {
      return value ? value.endsWith('@gmail.com') : false;
    })
});

export const changeNumberSchema = Yup.object().shape({
  cellNumber: Yup.string()
    .required('Mobile number required')
    .min(10, 'Mobile number must be at least 10 digits')
    .test('is-valid-whatsapp', 'Invalid WhatsApp number', (value) => {
      return value && value.length >= 10; // basic validation for length, you can customize as needed
    }),
  pinCode: Yup.string()
    .matches(/^\d+$/, 'Pin code must be a number')
    .max(6, 'Pin code must be at most 4 digits')
    .required('Pin code is required')
});

export const cellNumberSchema = Yup.object().shape({
  cellNumber: Yup.string()
    .required('Mobile number required')
    .min(10, 'Mobile number must be at least 10 digits')
    .test('is-valid-whatsapp', 'Invalid WhatsApp number', (value) => {
      return value && value.length >= 10; // basic validation for length, you can customize as needed
    })
});

export const forgotPinCodeSchema = Yup.object().shape({
  pinCode: Yup.string()
    .matches(/^\d+$/, 'Pin code must be a number')
    .max(6, 'Pin code must be at most 4 digits')
    .required('Pin code is required'),
  confirmPinCode: Yup.string()
    .oneOf([Yup.ref('pinCode'), null], "Confirm pin codes don't match")
    .matches(/^\d+$/, 'Confirm pin code must be a number')
    .required('Confirm pin code is required')
});
export const changePinCodeSchema = Yup.object().shape({
  currentPinCode: Yup.string()
    .matches(/^\d+$/, 'Pin code must be a number')
    .max(6, 'Pin code must be at most 4 digits')
    .required('Pin code is required'),
  newPinCode: Yup.string()
    .matches(/^\d+$/, 'Pin code must be a number')
    .max(6, 'Pin code must be at most 4 digits')
    .required('Pin code is required'),
  confirmPinCode: Yup.string()
    .oneOf([Yup.ref('newPinCode'), null], "New pin codes don't match")
    .matches(/^\d+$/, 'Confirm pin code must be a number')
    .required('Confirm pin code is required')
});

export const followUpSchema = Yup.object().shape({
  day: Yup.string().required('Day is required'),
  selectedTime: Yup.object()
    .shape({
      timeFrom: Yup.string().required('Hour is required'),
      timeTo: Yup.string().required('Minute is required')
    })
    .required('Service is required') // Ensures the object itself is required
});

export const opdFeeSchema = Yup.object().shape({
  opdFee: Yup.number()
    .required('Service fee is required')
    .moreThan(0, 'Service fee must be greater than zero')
});
